































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { StoryUser } from '../StoryUser';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import { RawLocation } from 'vue-router';
import { globalUC } from '../UserCache';

@Component({
  name: 'UrgencyAndSignUpButtonComponent',
  components: {
    ModalWrapperComponent: () => import('@/components/ModalWrapperComponent.vue'),
  }
})
export default class UrgencyAndSignUpButton extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public urgencyText: string

  @Prop({ default: null })
  public optimizeForFacebook: boolean

  // public reactive member variables available to the html template
  public buttonCTA: string = null
  public email: string = null;

  public userChoseFacebookLogin(): void {
    utils_auth.setLocationAfterLogin({ name: "home" });
    (window as any).analytics.track('User ClickedFBLogin')
    this.$fb.login()
  }

  public onOK(): void {
    if (!this.email || this.email.length === 0 || !utils.isValidEmail(this.email)) {
      utils.toast(this, 'Missing field', 'Please enter a valid email address.')
      return
    }
    utils_auth.setLocationAfterLogin({ name: "home" });
    (this.$refs.RegisterFormModalComponent as any).show('Sign Up', 'sm', { email: this.email })
  }

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get emailPlaceholder(): string { return "your email address" }


  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name)

  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
